(function () {
  "use strict";

  var DLX = window.DLX || {};

  /* ------------------------------------------------------------------ */
  /* Helpers                                                             */
  /* ------------------------------------------------------------------ */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = DLX.moneyFormat || "${{amount}}";
    return format.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function getLinkUrl(link) {
    if (!link) return "#";
    if (/^https?:\/\//.test(link) || link.charAt(0) === "#") return link;
    return link.charAt(0) === "/" ? link : "/" + link;
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------------ */
  /* Swiper carousels                                                    */
  /* ------------------------------------------------------------------ */
  function initSwipers() {
    if (typeof Swiper === "undefined") return;

    var hero = qs("[data-hero-carousel]");
    if (hero) {
      new Swiper(hero, {
        loop: true,
        speed: 700,
        grabCursor: true,
        keyboard: { enabled: true },
        autoplay: { delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true },
        navigation: { prevEl: ".dlx-hero-prev", nextEl: ".dlx-hero-next" },
        pagination: { el: ".dlx-hero-pagination", clickable: true }
      });
    }

    var popular = qs("[data-swiper-popular]");
    if (popular) {
      new Swiper(popular, {
        spaceBetween: 24,
        slidesPerView: 1,
        autoplay: { delay: 4000, disableOnInteraction: false, pauseOnMouseEnter: true },
        breakpoints: {
          400: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 }
        }
      });
    }

    var thumbsEl = qs("[data-gallery-thumbs]");
    var thumbsSwiper = thumbsEl
      ? new Swiper(thumbsEl, { watchSlidesProgress: true, freeMode: true, slidesPerView: "auto", spaceBetween: 10 })
      : null;

    var mainGalleryEl = qs("[data-gallery-main]");
    if (mainGalleryEl) {
      var mainSwiper = new Swiper(mainGalleryEl, {
        navigation: { prevEl: ".gal-prev", nextEl: ".gal-next" },
        pagination: { el: ".gal-dots", clickable: true },
        thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined
      });

      // Swiper's built-in thumb-click-to-navigate doesn't reliably fire when
      // all thumbnails already fit on screen (freeMode has nothing to slide
      // to), so wire the click ourselves rather than depend on it.
      if (thumbsEl) {
        qsa(".swiper-slide", thumbsEl).forEach(function (slide, index) {
          slide.addEventListener("click", function () {
            mainSwiper.slideTo(index);
          });
        });
      }
    }
  }

  /* ------------------------------------------------------------------ */
  /* FAQ accordion (homepage + product page)                             */
  /* ------------------------------------------------------------------ */
  function initFaqAccordions() {
    qsa("[data-faq-accordion]").forEach(function (root) {
      qsa("[data-faq-toggle]", root).forEach(function (btn) {
        btn.addEventListener("click", function () {
          var item = btn.closest(".dlx-faq-item");
          var panel = qs("[data-faq-panel]", item);
          var icon = qs("[data-faq-icon]", item);
          var isOpen = item.classList.contains("dlx-faq-open");

          qsa(".dlx-faq-item", root).forEach(function (other) {
            other.classList.remove("dlx-faq-open");
            qs("[data-faq-panel]", other).classList.remove("grid-rows-[1fr]");
            qs("[data-faq-panel]", other).classList.add("grid-rows-[0fr]");
            qs("[data-faq-toggle]", other).setAttribute("aria-expanded", "false");
            var oIcon = qs("[data-faq-icon]", other);
            oIcon.classList.remove("bg-primary", "text-white");
            oIcon.classList.add("bg-[#B8860B]/10", "text-primary");
          });

          if (!isOpen) {
            item.classList.add("dlx-faq-open");
            panel.classList.remove("grid-rows-[0fr]");
            panel.classList.add("grid-rows-[1fr]");
            btn.setAttribute("aria-expanded", "true");
            icon.classList.remove("bg-[#B8860B]/10", "text-primary");
            icon.classList.add("bg-primary", "text-white");
          }
        });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Mega menu (desktop) + mobile menu                                   */
  /* ------------------------------------------------------------------ */
  function buildDesktopPanel(category) {
    var sub = category.subCategories || [];
    var firstSub = sub[0];
    var html = '<div class="border border-gray-200 flex min-h-[460px]">';

    html += '<div class="w-[20%] bg-surface border-r border-gray-200 flex flex-col justify-between px-2 py-2">';
    html += '<div class="flex flex-col gap-1.5" data-mega-subcats>';
    sub.forEach(function (s, i) {
      html +=
        '<button type="button" data-subcat-index="' + i + '" class="mega-subcat-btn text-left text-sm font-semibold px-4 py-3 transition-all w-full flex items-center justify-between group ' +
        (i === 0 ? "bg-[#fdf2c0] text-primary border-l-4 border-primary" : "text-gray-700 hover:bg-gray-100 hover:text-primary") +
        '">' + s.title + "</button>";
    });
    html += "</div></div>";

    html += '<div class="flex-1 flex" data-mega-content></div>';
    html += "</div>";

    var wrap = document.createElement("div");
    wrap.innerHTML = html;
    renderSubcatContent(wrap.querySelector("[data-mega-content]"), firstSub);

    wrap.querySelectorAll(".mega-subcat-btn").forEach(function (btn, i) {
      btn.addEventListener("click", function () {
        wrap.querySelectorAll(".mega-subcat-btn").forEach(function (b) {
          b.classList.remove("bg-[#fdf2c0]", "text-primary", "border-l-4", "border-primary");
          b.classList.add("text-gray-700");
        });
        btn.classList.add("bg-[#fdf2c0]", "text-primary", "border-l-4", "border-primary");
        renderSubcatContent(wrap.querySelector("[data-mega-content]"), sub[i]);
      });
    });

    return wrap.firstChild;
  }

  function renderSubcatContent(container, subcat) {
    if (!container) return;
    if (!subcat) return;

    if (subcat.products && subcat.products.length) {
      var pHtml = '<div class="flex w-full flex-col">';
      pHtml += '<div class="grid grid-cols-3 gap-4 p-6">';
      subcat.products.forEach(function (p) {
        pHtml += '<a href="' + getLinkUrl(p.link) + '" class="group flex flex-col items-center text-center">';
        pHtml += '<div class="w-full aspect-square overflow-hidden rounded-md bg-surface mb-2"><div class="h-full w-full bg-cover bg-center transition-transform duration-300 group-hover:scale-105" style="background-image:url(' + p.image + ')"></div></div>';
        pHtml += '<span class="text-xs text-gray-700 group-hover:text-primary">' + p.name + "</span></a>";
      });
      pHtml += "</div>";
      pHtml += '<a href="' + getLinkUrl(subcat.link) + '" class="flex items-center justify-center gap-1 rounded-b bg-secondary px-3 py-3 text-sm font-medium text-white cursor-pointer">Browse all ' + subcat.title + " »</a>";
      pHtml += "</div>";
      container.innerHTML = pHtml;
      return;
    }

    if (!subcat.columns || !subcat.columns.length) {
      container.innerHTML =
        '<div class="flex w-full flex-col items-center justify-center gap-3 px-8 py-10 text-center">' +
        '<p class="text-sm text-gray-500">' + (subcat.productsCount > 0 ? "Browse all " + subcat.title + " products." : "Products for " + subcat.title + " are coming soon.") + "</p>" +
        (subcat.productsCount > 0
          ? '<a href="' + getLinkUrl(subcat.link) + '" class="inline-flex items-center gap-1 rounded-full bg-primary px-5 py-2 text-sm font-semibold text-white hover:bg-primary/90">Browse ' + subcat.title + "</a>"
          : "") +
        "</div>";
      return;
    }

    var first = subcat.columns[0] && subcat.columns[0][0] && subcat.columns[0][0].products && subcat.columns[0][0].products[0];

    var html = '<div class="w-[70%] flex flex-col justify-between">';
    html += '<div class="grid grid-cols-4 gap-6 py-6 px-8">';
    subcat.columns.forEach(function (col) {
      html += '<div class="flex flex-col gap-4">';
      col.forEach(function (section) {
        html += '<div><a href="' + getLinkUrl(section.link) + '" class="text-primary text-sm font-semibold flex items-center mb-2 hover:underline">' + section.sectionTitle + "</a><ul class=\"space-y-1\">";
        section.products.forEach(function (p) {
          html += '<li class="border-b border-gray-200 border-dashed pb-1"><a href="' + getLinkUrl(p.link) + '" data-hover-product=\'' + JSON.stringify(p).replace(/'/g, "&#39;") + '\' class="mega-product-link text-sm block w-full transition-colors text-gray-600 hover:text-primary">' + p.name + "</a></li>";
        });
        html += "</ul></div>";
      });
      html += "</div>";
    });
    html += "</div>";
    html += '<a href="' + getLinkUrl(subcat.link) + '" class="flex items-center justify-between rounded-r px-3 py-3 text-white cursor-pointer border-l-[3px] border-l-primary bg-secondary"><span class="text-sm font-medium">' + subcat.title + '</span><span class="flex items-center gap-1 text-xs text-white">Browse all »</span></a>';
    html += "</div>";

    html += '<div class="w-[30%] border-l py-6 px-8 border-gray-200" data-featured-panel>';
    if (first) html += renderFeatured(first, subcat.mostPopular);
    html += "</div>";

    container.innerHTML = html;

    qsa("[data-hover-product]", container).forEach(function (link) {
      link.addEventListener("mouseenter", function () {
        var p = JSON.parse(link.getAttribute("data-hover-product"));
        container.querySelector("[data-featured-panel]").innerHTML = renderFeatured(p, subcat.mostPopular);
      });
    });
  }

  function renderFeatured(product, mostPopular) {
    var html = '<div class="flex flex-col items-center">';
    html += '<a href="' + getLinkUrl(product.link) + '" class="w-full bg-surface rounded-md flex flex-col items-center mb-6">';
    html += '<div class="w-full aspect-square bg-cover bg-center rounded-t-md bg-no-repeat" style="background-image:url(' + product.image + ')"></div>';
    html += '<p class="text-gray-800 text-center font-semibold text-sm my-2">' + product.name + "</p></a>";
    if (mostPopular && mostPopular.length) {
      html += '<div class="w-full"><h4 class="text-sm font-bold text-gray-800 mb-2">Most Popular</h4><div class="grid grid-cols-3 gap-3">';
      mostPopular.forEach(function (pop) {
        html += '<a href="' + getLinkUrl(pop.link) + '" class="flex flex-col items-center border border-gray-100 rounded-sm bg-surface hover:border-primary transition-colors">';
        html += '<div class="w-full h-18 bg-cover rounded-t-sm bg-center bg-no-repeat" style="background-image:url(' + pop.image + ')"></div>';
        html += '<span class="text-[10px] text-center font-medium text-gray-700 leading-tight my-2">' + pop.name + "</span></a>";
      });
      html += "</div></div>";
    }
    html += "</div>";
    return html;
  }

  function initMegaMenu() {
    var root = qs("[data-mega-menu-root]");
    if (!root) return;

    var panel = qs("[data-mega-panel]", root);
    var backdrop = qs("[data-mega-backdrop]", root);
    var closeTimer = null;

    function closeDesktop() {
      panel.hidden = true;
      panel.classList.add("hidden");
      backdrop.hidden = true;
      backdrop.classList.add("hidden");
      qsa("[data-menu-trigger]", root).forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeDesktop, 200);
    }

    function cancelClose() {
      clearTimeout(closeTimer);
    }

    function openFor(trigger) {
      var key = trigger.getAttribute("data-menu-trigger");
      var data = (window.DLX_MEGA_MENU || []).find(function (c) {
        return (c.title || "").toLowerCase().replace(/[^a-z0-9]+/g, "-") === key;
      });
      if (!data) return;

      qsa("[data-menu-trigger]", root).forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
      panel.innerHTML = "";
      panel.appendChild(buildDesktopPanel(data));
      panel.hidden = false;
      panel.classList.remove("hidden");
      backdrop.hidden = false;
      backdrop.classList.remove("hidden");
      trigger.setAttribute("aria-expanded", "true");
    }

    qsa("[data-menu-trigger]", root).forEach(function (trigger) {
      trigger.addEventListener("mouseenter", function () {
        cancelClose();
        openFor(trigger);
      });
      trigger.addEventListener("mouseleave", scheduleClose);
      trigger.addEventListener("focus", function () { openFor(trigger); });
    });

    panel.addEventListener("mouseenter", cancelClose);
    panel.addEventListener("mouseleave", scheduleClose);

    backdrop.addEventListener("click", closeDesktop);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDesktop(); });

    /* ---- Mobile ---- */
    var mobileToggle = qs("[data-mobile-menu-toggle]");
    var mobileMenu = qs("[data-mobile-menu]");
    if (!mobileToggle || !mobileMenu) return;

    var mobileOpen = false;
    function closeMobile() {
      mobileOpen = false;
      mobileMenu.classList.add("hidden");
      mobileMenu.classList.remove("flex");
      document.body.style.overflow = "";
      mobileToggle.setAttribute("aria-expanded", "false");
    }

    function renderMobileMenu(activeIndex) {
      var cats = window.DLX_MEGA_MENU_MOBILE || [];
      var active = cats[activeIndex];
      var html = '<div class="flex flex-1 overflow-hidden">';
      html += '<nav class="w-[35%] bg-gray-50 border-r border-gray-100 flex flex-col">';
      cats.forEach(function (c, i) {
        html += '<button type="button" data-mobile-cat="' + i + '" class="w-full text-left px-3 py-3 text-[13px] border-l-[3px] ' +
          (i === activeIndex ? "border-l-primary bg-[#FDF2C0] text-primary font-medium" : "border-l-transparent text-gray-500") + '">' + c.title + "</button>";
      });
      html += "</nav>";
      html += '<main class="flex-1 overflow-y-auto p-3">';
      if (active) {
        html += '<a href="' + getLinkUrl(active.link) + '" class="text-primary text-[15px] font-medium flex items-center gap-1 mb-3">' + active.title + " »</a>";
        if (active.subCategories && active.subCategories.length) {
          html += '<div class="flex flex-col gap-1">';
          active.subCategories.forEach(function (s) {
            html += '<a href="' + getLinkUrl(s.link) + '" class="rounded-lg border border-gray-100 bg-surface px-3 py-2.5 text-[13.5px] text-gray-700 hover:text-primary">' + s.title + "</a>";
          });
          html += "</div>";
        } else if (active.columns) {
          active.columns.forEach(function (col) {
            col.forEach(function (section) {
              html += '<div class="mt-4"><div class="text-[13px] font-medium text-gray-800 mb-2 border-b border-gray-100 pb-2">' + section.sectionTitle + "</div>";
              html += '<div class="grid grid-cols-3 gap-2">';
              section.products.forEach(function (p) {
                html += '<a href="' + getLinkUrl(p.link) + '" class="block rounded-lg overflow-hidden border border-gray-100 bg-surface">';
                html += '<div class="w-full aspect-square bg-cover bg-center" style="background-image:url(' + p.image + ')"></div>';
                html += '<div class="text-[10px] text-center text-gray-700 px-1 py-1.5">' + p.name + "</div></a>";
              });
              html += "</div></div>";
            });
          });
        } else {
          html += '<p class="text-sm text-gray-400 mt-4">Tap the link above to explore this section.</p>';
        }
      }
      html += "</main></div>";
      mobileMenu.innerHTML = html;

      qsa("[data-mobile-cat]", mobileMenu).forEach(function (btn) {
        btn.addEventListener("click", function () { renderMobileMenu(parseInt(btn.getAttribute("data-mobile-cat"), 10)); });
      });
    }

    mobileToggle.addEventListener("click", function () {
      mobileOpen = !mobileOpen;
      if (mobileOpen) {
        renderMobileMenu(0);
        mobileMenu.classList.remove("hidden");
        mobileMenu.classList.add("flex");
        document.body.style.overflow = "hidden";
        mobileToggle.setAttribute("aria-expanded", "true");
      } else {
        closeMobile();
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Rotating search placeholder                                         */
  /* ------------------------------------------------------------------ */
  var SEARCH_PLACEHOLDER_WORDS = ["mugs?", "bottles?", "tote bags?", "notebooks?", "gift sets?", "banners?"];

  function initSearchPlaceholder() {
    qsa("[data-search-placeholder-rotator]").forEach(function (rotator) {
      var wordEl = qs("[data-search-placeholder-word]", rotator);
      var root = rotator.closest("[data-search-root]");
      var input = root && qs("[data-search-input]", root);
      if (!wordEl || !input) return;

      var index = 0;
      var timer = null;

      function showWord(i) {
        wordEl.style.opacity = "0";
        wordEl.style.transform = "translateY(4px)";
        setTimeout(function () {
          wordEl.textContent = SEARCH_PLACEHOLDER_WORDS[i];
          wordEl.style.opacity = "1";
          wordEl.style.transform = "translateY(0)";
        }, 180);
      }

      function tick() {
        index = (index + 1) % SEARCH_PLACEHOLDER_WORDS.length;
        showWord(index);
      }

      function start() {
        if (timer) return;
        timer = setInterval(tick, 2200);
      }
      function stop() {
        clearInterval(timer);
        timer = null;
      }

      function syncVisibility() {
        var hide = input.value.length > 0;
        rotator.style.opacity = hide ? "0" : "1";
        if (hide) stop(); else start();
      }

      input.addEventListener("input", syncVisibility);
      syncVisibility();
      start();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Predictive search                                                    */
  /* ------------------------------------------------------------------ */
  function initSearch() {
    qsa("[data-search-root]").forEach(function (root) {
      var input = qs("[data-search-input]", root);
      var resultsEl = qs("[data-search-results]", root);
      var emptyEl = qs("[data-search-empty]", root);
      var emptyTerm = qs("[data-search-empty-term]", root);
      var waLink = qs("[data-search-whatsapp-link]", root);
      if (!input) return;

      var debounceTimer;
      input.addEventListener("input", function () {
        clearTimeout(debounceTimer);
        var term = input.value.trim();
        if (!term) {
          resultsEl.classList.add("hidden");
          emptyEl.classList.add("hidden");
          return;
        }
        debounceTimer = setTimeout(function () { runSearch(term); }, 200);
      });

      document.addEventListener("click", function (e) {
        if (!root.contains(e.target)) {
          resultsEl.classList.add("hidden");
          emptyEl.classList.add("hidden");
        }
      });

      function runSearch(term) {
        var url = DLX.routes.predictiveSearchUrl + "?q=" + encodeURIComponent(term) +
          "&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type&section_id=predictive-search";
        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length) {
              resultsEl.innerHTML = products.map(function (p) {
                return '<a href="' + p.url + '" class="flex items-center gap-3 px-2 py-2 hover:bg-[#fdf2c0]">' +
                  (p.image ? '<img src="' + p.image + '" alt="" class="h-14 w-14 rounded-md object-contain">' : "") +
                  '<span class="text-sm text-slate-700">' + p.title + "</span></a>";
              }).join("");
              resultsEl.classList.remove("hidden");
              emptyEl.classList.add("hidden");
            } else {
              resultsEl.classList.add("hidden");
              if (emptyTerm) emptyTerm.textContent = term;
              if (waLink) waLink.href = "https://api.whatsapp.com/send?phone=" + DLX.whatsapp + "&text=" + encodeURIComponent('Hello! I am looking for "' + term + '". Can you help?');
              emptyEl.classList.remove("hidden");
            }
          })
          .catch(function () {});
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Shop the look hotspots                                              */
  /* ------------------------------------------------------------------ */
  function initShopTheLook() {
    qsa("[data-shop-the-look]").forEach(function (root) {
      var activeId = null;

      function closeAll() {
        activeId = null;
        qsa("[data-stl-card]", root).forEach(function (c) { c.classList.add("hidden"); });
        var mCard = qs("[data-stl-mobile-card]", root);
        if (mCard) mCard.classList.add("hidden");
      }

      qsa("[data-stl-hotspot]", root).forEach(function (hotspot) {
        var toggle = qs("[data-stl-toggle]", hotspot);
        var card = qs("[data-stl-card]", hotspot);
        if (!toggle) return;
        toggle.addEventListener("click", function (e) {
          e.stopPropagation();
          var id = hotspot.getAttribute("data-id");
          var willOpen = activeId !== id;
          closeAll();
          if (willOpen && card) {
            card.classList.remove("hidden");
            activeId = id;
          }
        });
      });

      document.addEventListener("click", function (e) {
        if (!root.contains(e.target)) closeAll();
      });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Cart: drawer, badge, add/remove/qty via Ajax API                    */
  /* ------------------------------------------------------------------ */
  var cartDrawer = null;

  function openCartDrawer() {
    cartDrawer = cartDrawer || qs("[data-cart-drawer]");
    if (!cartDrawer) return;
    cartDrawer.classList.remove("hidden");
    cartDrawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function closeCartDrawer() {
    cartDrawer = cartDrawer || qs("[data-cart-drawer]");
    if (!cartDrawer) return;
    cartDrawer.classList.add("hidden");
    cartDrawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function refreshCartBadge(itemCount) {
    qsa("[data-cart-count-badge]").forEach(function (el) {
      el.textContent = itemCount > 99 ? "99+" : itemCount;
      el.classList.toggle("hidden", itemCount === 0);
    });
    qsa("[data-cart-count-sr]").forEach(function (el) { el.textContent = itemCount + " items in cart"; });
  }

  function refreshCartDrawer() {
    fetch(DLX.routes.cartUrl + "?section_id=cart-drawer")
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("#cart-drawer-content");
        var current = qs("#cart-drawer-content");
        if (fresh && current) current.outerHTML = fresh.outerHTML;
        bindCartLineEvents();
      });
  }

  function bindCartLineEvents() {
    qsa("[data-cart-qty-increase]").forEach(function (btn) {
      btn.addEventListener("click", function () { changeLineQuantity(btn.getAttribute("data-line"), 1); });
    });
    qsa("[data-cart-qty-decrease]").forEach(function (btn) {
      btn.addEventListener("click", function () { changeLineQuantity(btn.getAttribute("data-line"), -1); });
    });
    qsa("[data-cart-remove]").forEach(function (btn) {
      btn.addEventListener("click", function () { setLineQuantity(btn.getAttribute("data-line"), 0); });
    });
  }

  function currentLineQty(line) {
    var lineEl = qs('[data-cart-line="' + line + '"]');
    var span = lineEl && qs("[data-cart-qty-value]", lineEl);
    return span ? parseInt(span.textContent, 10) : 1;
  }

  function changeLineQuantity(line, delta) {
    var next = Math.max(0, currentLineQty(line) + delta);
    setLineQuantity(line, next);
  }

  function setLineQuantity(line, quantity) {
    fetch(DLX.routes.cartChangeUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        refreshCartBadge(cart.item_count);
        var onCartPage = !!qs("[data-cart-line]:not([data-cart-drawer] [data-cart-line])") && window.location.pathname.indexOf("/cart") === 0;
        if (onCartPage) {
          window.location.reload();
        } else {
          refreshCartDrawer();
        }
      });
  }

  function initProductForm() {
    var form = qs("[data-product-form]");
    if (!form) return;

    var qtyInput = qs("[data-qty-input]", form);
    qs("[data-qty-increase]", form) && qs("[data-qty-increase]", form).addEventListener("click", function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value || "1", 10) + 1);
      qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
    });
    qs("[data-qty-decrease]", form) && qs("[data-qty-decrease]", form).addEventListener("click", function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value || "1", 10) - 1);
      qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
    });

    var variantSelect = qs("[data-variant-id-select]", form);
    var optionSelectors = qsa("[data-option-selector]", form);
    var priceEl = qs("[data-product-price]", form.closest("[data-product-root]"));
    var comparePriceEl = qs("[data-product-compare-price]", form.closest("[data-product-root]"));
    var addBtn = qs("[data-add-to-cart]", form);
    var addBtnText = qs("[data-add-to-cart-text]", form);
    var unavailableMsg = qs("[data-unavailable-msg]", form.closest("[data-product-root]"));

    function currentSelection() {
      return optionSelectors.map(function (sel) { return sel.value; });
    }

    function findMatchingVariant() {
      var selection = currentSelection();
      var options = variantSelect ? qsa("option", variantSelect) : [];
      for (var i = 0; i < options.length; i++) {
        var values = (options[i].getAttribute("data-option-values") || "").split("|||");
        if (selection.every(function (v, idx) { return values[idx] === v; })) return options[i];
      }
      return null;
    }

    var skuEl = qs("[data-product-sku]", form.closest("[data-product-root]"));
    var stockEl = qs("[data-product-stock]", form.closest("[data-product-root]"));

    function applyVariant(match) {
      if (!match) {
        if (addBtn) addBtn.disabled = true;
        if (addBtnText) addBtnText.textContent = "Unavailable";
        if (unavailableMsg) unavailableMsg.classList.remove("hidden");
        return;
      }
      if (variantSelect) variantSelect.value = match.value;

      var available = match.getAttribute("data-available") !== "false";
      if (unavailableMsg) unavailableMsg.classList.toggle("hidden", available);
      if (addBtn) addBtn.disabled = !available;
      if (addBtnText) addBtnText.textContent = available ? "Add to Cart" : "Sold Out";

      var price = match.getAttribute("data-price");
      if (priceEl && price) priceEl.textContent = price;
      if (comparePriceEl) {
        if (match.getAttribute("data-has-compare") === "1") {
          comparePriceEl.textContent = match.getAttribute("data-compare-price") || "";
          comparePriceEl.classList.remove("hidden");
        } else {
          comparePriceEl.classList.add("hidden");
        }
      }

      var sku = match.getAttribute("data-sku");
      if (skuEl && sku) skuEl.textContent = sku;

      if (stockEl) {
        var tracked = match.getAttribute("data-inventory-tracked");
        var policy = match.getAttribute("data-inventory-policy");
        var qty = parseInt(match.getAttribute("data-inventory-qty") || "0", 10);
        if (!available) {
          stockEl.textContent = "Out of Stock";
          stockEl.className = "font-medium text-slate-400";
        } else if (tracked && policy !== "continue" && qty > 0) {
          stockEl.textContent = "In Stock (" + qty + " available)";
          stockEl.className = "font-medium text-green-600";
        } else {
          stockEl.textContent = "In Stock";
          stockEl.className = "font-medium text-green-600";
        }
      }
    }

    optionSelectors.forEach(function (sel) {
      sel.addEventListener("change", function () {
        applyVariant(findMatchingVariant());
      });
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      addBtn.disabled = true;
      var formData = new FormData(form);
      fetch(DLX.routes.cartAddUrl + ".js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          addBtn.disabled = false;
          if (!res.ok) {
            if (addBtnText) addBtnText.textContent = res.data.description || "Could not add to cart";
            return;
          }
          fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
            refreshCartBadge(cart.item_count);
            if (DLX.cartType === "page") {
              window.location.href = DLX.routes.cartUrl;
            } else {
              refreshCartDrawer();
              openCartDrawer();
            }
          });
        })
        .catch(function () { addBtn.disabled = false; });
    });
  }

  function initBulkPricing() {
    var wrap = qs("[data-bulk-pricing]");
    if (!wrap) return;
    var buttons = qsa("[data-bulk-tier]", wrap);
    var display = qs("[data-bulk-price-display]", wrap);
    var productRoot = wrap.closest("[data-product-root]");
    var qtyInput = productRoot ? qs("[data-qty-input]", productRoot) : null;
    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        buttons.forEach(function (b) {
          b.classList.remove("active", "bg-primary", "border-primary", "text-white");
          b.classList.add("border-slate-200", "text-slate-600");
          b.setAttribute("aria-pressed", "false");
        });
        btn.classList.add("active", "bg-primary", "border-primary", "text-white");
        btn.classList.remove("border-slate-200", "text-slate-600");
        btn.setAttribute("aria-pressed", "true");
        if (display) display.textContent = btn.getAttribute("data-bulk-price-formatted");
        if (qtyInput) {
          var tierQty = parseInt(btn.getAttribute("data-bulk-qty"), 10);
          if (tierQty) qtyInput.value = tierQty;
        }
      });
    });

    if (qtyInput) {
      qtyInput.addEventListener("input", function () {
        var qty = parseInt(qtyInput.value, 10) || 1;
        var best = null;
        buttons.forEach(function (b) {
          var bQty = parseInt(b.getAttribute("data-bulk-qty"), 10);
          if (qty >= bQty && (!best || bQty > parseInt(best.getAttribute("data-bulk-qty"), 10))) best = b;
        });
        if (best) {
          buttons.forEach(function (b) {
            b.classList.remove("active", "bg-primary", "border-primary", "text-white");
            b.classList.add("border-slate-200", "text-slate-600");
            b.setAttribute("aria-pressed", "false");
          });
          best.classList.add("active", "bg-primary", "border-primary", "text-white");
          best.classList.remove("border-slate-200", "text-slate-600");
          best.setAttribute("aria-pressed", "true");
          if (display) display.textContent = best.getAttribute("data-bulk-price-formatted");
        }
      });
    }
  }

  function initCartChrome() {
    document.addEventListener("click", function (e) {
      var closeBtn = e.target.closest("[data-cart-drawer-close]");
      if (closeBtn) { closeCartDrawer(); return; }

      var opener = e.target.closest("[data-cart-icon-bubble]");
      if (opener && DLX.cartType === "drawer") {
        e.preventDefault();
        refreshCartDrawer();
        openCartDrawer();
      }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCartDrawer(); });
    bindCartLineEvents();
  }

  /* ------------------------------------------------------------------ */
  /* Init                                                                 */
  /* ------------------------------------------------------------------ */
  document.addEventListener("DOMContentLoaded", function () {
    initSwipers();
    initFaqAccordions();
    initMegaMenu();
    initSearchPlaceholder();
    initSearch();
    initShopTheLook();
    initProductForm();
    initBulkPricing();
    initCartChrome();
  });
})();
